export enum ImportCDFWorkflowStatus {
  AUTO_VALIDATION_COMPLETED = "Auto-Validation Completed",
  AUTO_VALIDATION_FAILED = "Auto-Validation Failed",
  IMPORT_COMPLETE = "Complete",
  IMPORT_IN_PROGRESS = "In Progress",
  IMPORT_FAILED = "Failed",
  IN_VALIDATION = "In Validation",
  COMPLETED_AND_VALIDATED = "Completed and Validated",
  MERGING_IN_PROGRESS = "Merging in Progress",
  DISCARDING_IN_PROGRESS = "Discarding in Progress",
  DISCARDED = "Discarded"
}
